// Domains accepted for the legacy smgAuthBase URL parameter while REACT_APP_SMG_AUTH_BASE is not configured.
// Remove the fallback once every deployment sets REACT_APP_SMG_AUTH_BASE (TEAM-2166).
const trustedSmgDomains = ['d4sp.com', 'telepo-smg.com'];

const identifierPattern = /^[A-Za-z0-9._-]+$/;

function parseHttpsUrl(value: string | null | undefined): URL | null {
  if (!value) {
    return null;
  }

  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.username || url.password) {
      return null;
    }
    return url;
  } catch {
    return null;
  }
}

function isTrustedHost(hostname: string): boolean {
  const host = hostname.toLowerCase();
  return trustedSmgDomains.some((domain) => host === domain || host.endsWith(`.${domain}`));
}

function normalizeAuthBase(url: URL): string {
  return `${url.origin}${url.pathname}`.replace(/\/+$/, '');
}

function toTrustedSmgAuthBase(value: string | null | undefined): string | null {
  const url = parseHttpsUrl(value);
  if (!url || url.search || url.hash || !isTrustedHost(url.hostname)) {
    return null;
  }
  return normalizeAuthBase(url);
}

// Read lazily so importing this helper does not require window._env_ to be defined.
function getConfiguredSmgAuthBase(): string | null {
  const url = parseHttpsUrl(window._env_?.REACT_APP_SMG_AUTH_BASE);
  return url ? normalizeAuthBase(url) : null;
}

function isValidIdentifier(value: string | null | undefined): value is string {
  return !!value && identifierPattern.test(value) && !/^\.+$/.test(value);
}

function isSafeHttpsUrl(value: string | null | undefined): value is string {
  return !!parseHttpsUrl(value);
}

export { toTrustedSmgAuthBase, getConfiguredSmgAuthBase, isValidIdentifier, isSafeHttpsUrl };
